var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.82031H14.5488C14.6702 10.6779 15.015 11.4671 15.5237 12.1278C15.8983 12.6914 16.3621 13.5035 16.8114 14.3734H6.32258V33.466H13.0363L15.3632 34.7813H5V9.82031ZM18.5241 34.7813H18.1861L15.8592 33.466H18.5241V34.7813ZM21.4312 34.7813H21.0879V33.466H23.7581L21.4312 34.7813ZM24.2541 34.7813H35V9.82031H24.6645C24.5492 10.6345 24.2325 11.3874 23.7653 12.027C23.381 12.6222 22.8951 13.4723 22.4254 14.3734H33.6397V33.466H26.581L24.2541 34.7813ZM8.86623 11.5826H7.57717V12.8717H8.86623V11.5826ZM10.388 11.5826H11.6771V12.8717H10.388V11.5826ZM14.491 11.5826H13.202V12.8717H14.491V11.5826Z",
    fill: "#1A1F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43164 16.0721H16.8585V16.8065H7.43164V16.0721Z",
    fill: "#1A1F36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.367 17.6633H7.43164V18.3977H13.367V17.6633Z",
    fill: "#1A1F36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1934 19.2545H7.43164V19.9889H8.1934V19.2545Z",
    fill: "#1A1F36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90737 19.2545H9.14561V19.9889H9.90737V19.2545Z",
    fill: "#1A1F36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6213 19.2545H10.8596V19.9889H11.6213V19.2545Z",
    fill: "#1A1F36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43164 22.3878H9.87563V23.1222H7.43164V22.3878Z",
    fill: "#1A1F36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5739 23.979H7.43164V24.7134H10.5739V23.979Z",
    fill: "#1A1F36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5703 16.0721H28.6425V16.8065H32.5703V16.0721Z",
    fill: "#1A1F36"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3218 17.6633H32.5703V18.3977H24.3218V17.6633Z",
    fill: "#1A1F36"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8569 19.2545H32.5703V19.9889H27.8569V19.2545Z",
    fill: "#1A1F36"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5703 22.3878H29.428V23.1222H32.5703V22.3878Z",
    fill: "#1A1F36"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.392 23.979H32.5703V24.7134H31.392V23.979Z",
    fill: "#1A1F36"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2182 21.9304L19.8107 18.3088L13.4006 21.9319L19.808 25.5434L26.2182 21.9304ZM27.5023 24.1028L21.09 27.7169L21.09 34.9753L27.5023 31.351V24.1028ZM18.5261 34.9723L18.5261 27.7169L12.1191 24.1058V31.351L18.5261 34.9723Z",
    fill: "#7B3BE3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7118 8.99386C23.7118 9.87059 23.4276 10.6809 22.9462 11.3377C21.9848 12.8572 20.4977 15.7812 19.9466 17.4587C19.9096 17.5713 19.5737 17.571 19.537 17.4582C18.9968 15.7951 17.5515 12.8714 16.5817 11.3949C16.5024 11.2906 16.428 11.1822 16.3591 11.0701L16.3503 11.058L16.3517 11.058C15.9848 10.4566 15.7734 9.74989 15.7734 8.99386C15.7734 6.80173 17.5505 5.02466 19.7426 5.02466C21.9348 5.02466 23.7118 6.80173 23.7118 8.99386ZM19.7397 11.5341C21.1427 11.5341 22.28 10.3967 22.28 8.99378C22.28 7.59081 21.1427 6.45349 19.7397 6.45349C18.3368 6.45349 17.1994 7.59081 17.1994 8.99378C17.1994 10.3967 18.3368 11.5341 19.7397 11.5341Z",
    fill: "#7B3BE3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.f475dca0cae1cc50d3f3a54636eb2f43.svg";
export { ForwardRef as ReactComponent };